import {
  ComponentRef,
  Directive,
  EmbeddedViewRef,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { CustomDomEvents } from '@utils/events/custom-events';
import { ElementErrorComponent } from './element-error.component';

interface ElementErrorDirectiveOptions {
  style?: string;
}

@Directive({ selector: '[rptHandleErrors]', standalone: true })
export class ElementErrorDirective implements OnInit, OnDestroy {
  @Input({ required: false, alias: 'rptHandleErrors' })
  public options: ElementErrorDirectiveOptions | unknown | undefined = undefined;

  private readonly templateRef: TemplateRef<unknown> = inject(TemplateRef);
  private readonly viewContainer: ViewContainerRef = inject(ViewContainerRef);
  private readonly renderer: Renderer2 = inject(Renderer2);
  private unlisten?: () => void;

  ngOnInit(): void {
    const view: EmbeddedViewRef<unknown> = this.viewContainer.createEmbeddedView(this.templateRef);
    const element: HTMLElement = view.rootNodes[0] as HTMLElement;
    this.unlisten = this.renderer.listen(element, CustomDomEvents.ELEMENT_LOAD_ERROR, this.onLoadError);
  }

  ngOnDestroy(): void {
    this.unlisten?.();
  }

  private readonly onLoadError = (event: CustomEvent<Error>): void => {
    this.unlisten();
    this.unlisten = undefined;
    const error: Error | undefined = event.detail;

    this.viewContainer.clear();

    const errorComponent: ComponentRef<ElementErrorComponent> = this.viewContainer.createComponent(ElementErrorComponent);
    const errorInputField: keyof ElementErrorComponent = 'error';
    errorComponent.setInput(errorInputField, error);

    const style: string | undefined = this.options?.['style'];
    if (style?.length > 0) {
      (errorComponent.location.nativeElement as HTMLElement).setAttribute('style', style);
    }

    event.stopPropagation();
  };
}
